module.exports = __webpack_public_path__ + "static/media/contact_def.e9ace2e2.png";